import { ILeanProductTile } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/MarketplaceProduct/LeanProtos/ILeanProductTile";
import { useSearchPageProductSearchString } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageProductSearchString";
import { LoggedOutSearchTileWrapper } from "@faire/deprecated-retailer-visitor-shared/views/search/__internal__/SearchProductsPage/__internal__/LoggedOutSearchTileWrapper";
import { Surface } from "@faire/web-api--source/faire/logging/data/Surface";
import { ProductTileContainer } from "@faire/web-api--source/indigofair/data/ProductTileContainer";
import { ProductTileScreenContainer } from "@faire/web-api--source/indigofair/data/ProductTileScreenContainer";
import { getSpacingValue } from "@faire/web/slate/spacing/getSpacing";
import { ResponsiveProp } from "@faire/web/slate/Theme/ResponsiveProp";
import { Carousel } from "@faire/web/ui-labs/Carousel/Carousel";

const ITEMS_PER_SLIDE: ResponsiveProp<number> = {
  mobileAndAbove: 2,
  tabletAndAbove: 4,
  desktopAndAbove: 5,
  xLargeAndAbove: 6,
};

export const DiscoverProductCarousel: React.FC<{
  products: ILeanProductTile[];
  brandMap?: Partial<Record<string, ILeanProductTile.IBrand>>;
  requestId?: string;
}> = ({ products, brandMap, requestId }) => {
  const searchTerm = useSearchPageProductSearchString();

  const renderItem = (item: ILeanProductTile, index: number) => {
    const brand = brandMap && brandMap[item?.product?.brand_token ?? ""];
    return (
      <LoggedOutSearchTileWrapper
        requestId={requestId}
        brand={brand}
        productTile={item}
        index={index}
        productTileScreen={Surface.SEARCH_PRODUCT_RESULTS}
        context={`${ProductTileContainer.SEARCH_PRODUCT_RESULTS_GRID}|${searchTerm}`}
        productTileContainer={ProductTileContainer.SEARCH_PRODUCT_RESULTS_GRID}
        contextToken={searchTerm ?? ""}
        containerContext={
          ProductTileScreenContainer.SEARCH_PRODUCT_RESULTS_PRIMARY_RESULTS
        }
      />
    );
  };

  return (
    <Carousel
      items={products}
      renderItem={renderItem}
      itemsPerSlide={ITEMS_PER_SLIDE}
      loop={false}
      showNavigationArrows={false}
      itemGap={{
        tabletAndAbove: getSpacingValue("3x"),
        mobileAndAbove: getSpacingValue("2x"),
      }}
    />
  );
};
